import Layout from "../components/Layout/Layout"
import EmployeesLayoutLoader from "../components/LayoutLoaders/EmployeesLayoutLoader"
import { useAppSelector } from "../hooks"
import { selectIsAllowUsersInLK } from "../redux/slice/auth"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import EmployeesByProjects from "../components/Employees/EmployeesByProjects/EmployeesByProjects"

export default function EmployeesPage() {
  const navigate = useNavigate()
  const isAllowUsersInLK = useAppSelector(selectIsAllowUsersInLK)

  useEffect(() => {
    if (!isAllowUsersInLK) navigate("/")
  }, [isAllowUsersInLK])

  return (
    <Layout mainLoader={<EmployeesLayoutLoader />} isHeaderMobHidden>
      <EmployeesByProjects />
    </Layout>
  )
}
